import { Modal } from '@vinted/web-ui';
import useTranslate from 'hooks/useTranslate';
import { jsx as _jsx } from "react/jsx-runtime";

const DeleteCollectionModal = _ref => {
  let {
    isOpen,
    onSubmit,
    onClose
  } = _ref;
  const translate = useTranslate('featured_collection.modals.delete');
  return /*#__PURE__*/_jsx(Modal, {
    show: isOpen,
    title: translate('title'),
    body: translate('text'),
    actions: [{
      text: translate('action'),
      style: Modal.ActionStyling.Filled,
      theme: 'warning',
      callback: onSubmit,
      testId: 'featured-collection-delete-modal--action-confirm'
    }, {
      text: translate('secondary_action'),
      theme: 'warning',
      callback: onClose
    }]
  });
};

export default DeleteCollectionModal;